var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { Component } from 'react';
import ReactDOM from 'react-dom';
import { css, StyleSheet } from 'aphrodite';
import { childrenPropType } from 'tss-core-lib-common';
import PropTypes from 'prop-types';

var modalRoot = document.getElementById('modal-root');
if (!modalRoot) {
  modalRoot = document.createElement('div');
  modalRoot.setAttribute('id', 'modal-root');
  modalRoot.setAttribute('style', 'position: fixed; z-index: 1000; width: 0; height: 0; left: 0; top: 0');
  document.body.appendChild(modalRoot);
}

var styles = void 0;

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.handleClick = function (event) {
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    };

    _this.el = document.createElement('div');
    _this.el.className = css(styles.container);
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      modalRoot.appendChild(this.el);
      window.addEventListener('keydown', this.handleClick);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      modalRoot.removeChild(this.el);
      window.removeEventListener('keydown', this.handleClick);
    }
  }, {
    key: 'render',
    value: function render() {
      return ReactDOM.createPortal(this.props.children, this.el);
    }
  }]);

  return Modal;
}(Component);

Modal.propTypes = {
  children: childrenPropType.isRequired,
  onKeyDown: PropTypes.func
};
Modal.defaultProps = {
  onKeyDown: null
};


styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.15)'
  }
});

export default Modal;